// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { EnumGender } from '../../../../../com/MetaPattern/APP/MDA/User/EnumGender';
import { EnumCertifyStatus } from '../../../../../com/MetaPattern/APP/MDA/User/EnumCertifyStatus';
import { EnumIdentityDocument } from '../../../../../com/MetaPattern/APP/MDA/User/EnumIdentityDocument';
import { Organization } from './Organization';
import { Tenancy } from './Tenancy';
/**
 * 人员信息 实体类
 * 人员的详细信息
 */
export class Person extends BaseEntity {
  /** 姓名 : 姓名 */
  private _name: string;

  /** 设置：姓名 */
  public get name() {
    return this._name;
  }

  /** 获取：姓名 */
  public set name(value: string) {
    this._name = value;
  }

  /** 手机号 : 手机号 */
  private _mobile: string;

  /** 设置：手机号 */
  public get mobile() {
    return this._mobile;
  }

  /** 获取：手机号 */
  public set mobile(value: string) {
    this._mobile = value;
  }

  /** 性别 : 性别 */
  private _gender: EnumGender;

  /** 设置：性别 */
  public get gender() {
    return this._gender;
  }

  /** 获取：性别 */
  public set gender(value: EnumGender) {
    this._gender = value;
  }

  /** 出生日期 : 出生日期 */
  private _birthDay: Date;

  /** 设置：出生日期 */
  public get birthDay() {
    return this._birthDay;
  }

  /** 获取：出生日期 */
  public set birthDay(value: Date) {
    this._birthDay = value;
  }

  /** 所在城市 : 所在城市，来源于系统应用 */
  private _cityId: string;

  /** 设置：所在城市 */
  public get cityId() {
    return this._cityId;
  }

  /** 获取：所在城市 */
  public set cityId(value: string) {
    this._cityId = value;
  }

  /** 行业 : 所在的行业 */
  private _industryId: string;

  /** 设置：行业 */
  public get industryId() {
    return this._industryId;
  }

  /** 获取：行业 */
  public set industryId(value: string) {
    this._industryId = value;
  }

  /** 实名认证状态 : 个人的的实名认证状态 */
  private _certifyStatus: EnumCertifyStatus;

  /** 设置：实名认证状态 */
  public get certifyStatus() {
    return this._certifyStatus;
  }

  /** 获取：实名认证状态 */
  public set certifyStatus(value: EnumCertifyStatus) {
    this._certifyStatus = value;
  }

  /** 证件类型 : 证件类型 */
  private _identityDocument: EnumIdentityDocument;

  /** 设置：证件类型 */
  public get identityDocument() {
    return this._identityDocument;
  }

  /** 获取：证件类型 */
  public set identityDocument(value: EnumIdentityDocument) {
    this._identityDocument = value;
  }

  /** 证件号码 : 证件号码 */
  private _iDNumber: string;

  /** 设置：证件号码 */
  public get iDNumber() {
    return this._iDNumber;
  }

  /** 获取：证件号码 */
  public set iDNumber(value: string) {
    this._iDNumber = value;
  }

  /** 证件正面照 : 身份证件的正面扫描文件 */
  private _iDCardFrontFile: string;

  /** 设置：证件正面照 */
  public get iDCardFrontFile() {
    return this._iDCardFrontFile;
  }

  /** 获取：证件正面照 */
  public set iDCardFrontFile(value: string) {
    this._iDCardFrontFile = value;
  }

  /** 证件反面 : 身份证件的反面扫描文件 */
  private _iDCardBackFile: string;

  /** 设置：证件反面 */
  public get iDCardBackFile() {
    return this._iDCardBackFile;
  }

  /** 获取：证件反面 */
  public set iDCardBackFile(value: string) {
    this._iDCardBackFile = value;
  }

  /** 机构 */
  private _organizations: Array<Organization>;

  /** 获取：机构 */
  public get organizations() {
    return this._organizations;
  }

  /** 设置：机构 */
  public set organizations(value: Array<Organization>) {
    this._organizations = value;
  }

  /** 租户 */
  private _tenancies: Array<Tenancy>;

  /** 获取：租户 */
  public get tenancies() {
    return this._tenancies;
  }

  /** 设置：租户 */
  public set tenancies(value: Array<Tenancy>) {
    this._tenancies = value;
  }

  constructor() {
    super();
    this._name = '';
    this._mobile = '';
    this._gender = EnumGender.None;
    this._birthDay = new Date();
    this._cityId = '';
    this._industryId = '';
    this._certifyStatus = EnumCertifyStatus.None;
    this._identityDocument = EnumIdentityDocument.IDCard;
    this._iDNumber = '';
    this._iDCardFrontFile = '';
    this._iDCardBackFile = '';
    this._organizations = new Array<Organization>();
    this._tenancies = new Array<Tenancy>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: Person, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.mobile = element.mobile;
      this.gender = element.gender;
      this.birthDay = element.birthDay;
      this.cityId = element.cityId;
      this.industryId = element.industryId;
      this.certifyStatus = element.certifyStatus;
      this.identityDocument = element.identityDocument;
      this.iDNumber = element.iDNumber;
      this.iDCardFrontFile = element.iDCardFrontFile;
      this.iDCardBackFile = element.iDCardBackFile;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.mobile = json.Mobile;
    this.gender = json.Gender as EnumGender;
    this.birthDay = new Date(json.BirthDay);
    this.cityId = json.CityId;
    this.industryId = json.IndustryId;
    this.certifyStatus = json.CertifyStatus as EnumCertifyStatus;
    this.identityDocument = json.IdentityDocument as EnumIdentityDocument;
    this.iDNumber = json.IDNumber;
    this.iDCardFrontFile = json.IDCardFrontFile;
    this.iDCardBackFile = json.IDCardBackFile;
    if (json.Organizations && json.Organizations.length > 0) {
      json.Organizations.forEach((element: any) => {
        const organization = Organization.Create(element);
        // organization.corporation = this;
        this.organizations.push(organization);
      });
    }
    if (json.Tenancies && json.Tenancies.length > 0) {
      json.Tenancies.forEach((element: any) => {
        const tenancy = Tenancy.Create(element);
        // tenancy.person = this;
        this.tenancies.push(tenancy);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Mobile = this.mobile;
    json.Gender = this.gender;
    json.BirthDay = this.birthDay;
    json.CityId = this.cityId;
    json.IndustryId = this.industryId;
    json.CertifyStatus = this.certifyStatus;
    json.IdentityDocument = this.identityDocument;
    json.IDNumber = this.iDNumber;
    json.IDCardFrontFile = this.iDCardFrontFile;
    json.IDCardBackFile = this.iDCardBackFile;
    if (this.organizations && this.organizations.length > 0) {
      json.Organizations = [];
      this.organizations.forEach((element) => {
        json.Organizations.push(element.toJson());
      });
    }
    if (this.tenancies && this.tenancies.length > 0) {
      json.Tenancies = [];
      this.tenancies.forEach((element) => {
        json.Tenancies.push(element.toJson());
      });
    }
  }

  static Create(json: any): Person {
    const person = new Person();
    person.Deserialize(json);
    person.json = json;
    return person;
  }
}
